import { render, staticRenderFns } from "./HelpDialog.vue?vue&type=template&id=5bdb68d9&scoped=true"
import script from "./HelpDialog.vue?vue&type=script&lang=js"
export * from "./HelpDialog.vue?vue&type=script&lang=js"
import style0 from "./HelpDialog.vue?vue&type=style&index=0&id=5bdb68d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb68d9",
  null
  
)

export default component.exports